import { AsyncPipe } from '@angular/common';
import { AfterViewInit, Component, DOCUMENT, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgIconComponent } from '@ng-icons/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BehaviorSubject, merge } from 'rxjs';
import { filter } from 'rxjs/operators';
import { EventsComponent } from 'src/app/components/events/events.component';
import { HeroComponent } from 'src/app/components/hero/hero.component';
import { KontaktComponent } from 'src/app/components/kontakt/kontakt.component';
import { MitgliederComponent } from 'src/app/components/mitglieder/mitglieder.component';
import { StudiumComponent } from 'src/app/components/studium/studium.component';
import { ToolbarComponent } from 'src/app/components/toolbar/toolbar.component';
import { IsVisibleDirective } from 'src/app/directives/is-visible.directive';
import { getWindow } from 'src/app/helpers/window';
import { FsLogoComponent } from '../../icons/fs-logo/fs-logo.component';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
  imports: [
    ToolbarComponent,
    HeroComponent,
    LazyLoadImageModule,
    StudiumComponent,
    EventsComponent,
    MitgliederComponent,
    KontaktComponent,
    AsyncPipe,
    IsVisibleDirective,
    NgIconComponent,
    FsLogoComponent,
  ],
})
export class MainPageComponent implements AfterViewInit {
  private route = inject(ActivatedRoute);
  public document = inject(DOCUMENT);

  #isInView = {
    hero: new BehaviorSubject<boolean>(true),
    studium: new BehaviorSubject<boolean>(false),
    events: new BehaviorSubject<boolean>(false),
    mitglieder: new BehaviorSubject<boolean>(false),
    kontakt: new BehaviorSubject<boolean>(false),
  } as const;

  // Section Images
  public heroImg = '../../assets/bg_images/uniwiese.jpg';
  public studiumImg = '../../assets/bg_images/philosophikum.jpg';
  public eventsImg = '../../assets/bg_images/hoersaalgebaeude.jpg';
  public kontaktImg = '../../assets/bg_images/hauptgebaeude.jpg';

  isVisible(visible: boolean, target: 'hero' | 'studium' | 'events' | 'mitglieder' | 'kontakt') {
    this.#isInView[target].next(visible);
  }

  // InView Observers
  get hero$() {
    return this.#isInView.hero.asObservable();
  }

  get studium$() {
    return this.#isInView.studium.asObservable();
  }

  get events$() {
    return this.#isInView.events.asObservable();
  }

  get mitglieder$() {
    return this.#isInView.mitglieder.asObservable();
  }

  get kontakt$() {
    return this.#isInView.kontakt.asObservable();
  }

  get toolbarHidden$() {
    // Toolbar is visible if hero and kontakt are not visible
    return merge(this.hero$.pipe(filter((_) => _)), this.kontakt$.pipe(filter((_) => _)));
  }

  ngAfterViewInit(): void {
    getWindow()?.requestAnimationFrame(() => {
      let hash = this.route.snapshot.fragment!;
      if (!hash) return;
      hash = hash.split('?').shift() ?? '';
      if (!hash) return;
      const element = this.document.getElementById(hash);
      if (!element) return;
      element.scrollIntoView();
    });
  }
}
